/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import React from 'react';
import { connect } from 'react-redux';
import { SaleCardViewDataTable } from 'shared/sale-card-view-datatable/SaleCardViewDataTable';
import { Form } from 'react-bootstrap';

import { advanceSearchSub, convertToMaintainData, enablePreviousState, getMaintainData } from 'shared/settings/stateMaintain';


import './ItemsForAdvanceSearch.scss';
import store from 'features/store';
/**


@Author Karthik

@param

@return html code for Advance search

**/
class ItemsForAdvanceSearch extends React.Component {
    constructor(props) {
        super(props);
        this.scrollRef = React.createRef();
        this.searchForm = {
            location: { value: 'All', show: false, name: 'Location' },
            category: { value: 'All', show: false, name: 'Category' },
            keywords: { value: '', show: false, name: 'Keywords' },
            includeDescription: { value: '', show: false, name: 'Include Description' },

            // Items location
            zipcode: { value: '', show: false, name: 'Zip code' },
            state: { value: '', show: false, name: 'State' },
            country: { value: '', show: false, name: 'Country' },
            miles: { value: '', show: false, name: 'Miles' },

            // Price range
            pricemin: { value: '', show: false, name: 'Price min' },
            pricemax: { value: '', show: false, name: 'Price max' },

            // Date
            startDate: { value: '', show: false, name: 'Start date' },
            endDate: { value: '', show: false, name: 'End date' },

            // Search only
            auction: { value: false, show: false, name: 'Auction' },
            directBuy: { value: false, show: false, name: 'Direct Buy' },
            onSite: { value: false, show: false, name: 'On Site Only' },
            completed: { value: false, show: false, name: 'Completed' },
            include: { value: false, show: false, name: 'Include sold items' },
            buynow: { value: false, show: false, name: 'Buy now' },
            noreserve: { value: false, show: false, name: 'No reserve' },
            pictureOnly: { value: false, show: false, name: 'Picture only' },
            isshippable: { value: false, show: false, name: 'Shippable' },
            pickuponly: { value:false, error: false, name: 'Pick up only' },

            // Sortby
            sortBy: { value: '', show: false, name: 'Sort by' },
        };
        this.state = {

            /* To handle responsive */
            innerWidth: window.innerWidth,
            pageLoading: true,

            unique: {
                "sort": [{ "field": "buyerspremium", "direction": "asc" }],
                "page": { "size": 48 }
            },
            displayData: {
                header: null,
                patchData: {
                    "sort": [{ "field": "SKU", "direction": "asc" }],
                    "page": { "size": 48 }
                }
            },
            searchForm: Object.assign({}, this.searchForm),
            searchData: null,
            clearAll: false,
            noData: true,
            scrollHeight: 220,
            isVisible: false,
            scrollTo: 0,
            pageClientWidth: 16
        };
        this.params = this.props.match.params;
    }

    componentDidMount() {
        this.paramsDecrypt();
        window.addEventListener('resize', this.headerStickyHandle);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.encryptData !== this.props.match.params.encryptData) {
            this.params = this.props.match.params;
            this.paramsDecrypt();
        }
        window.addEventListener('resize', this.headerStickyHandle);
    }

    getRequiredData = (applyScroll) => {
        if (applyScroll) {
            this.getPreviousValues();
        }
    }

    scrollToPrevious = () => {
        this.scrollRef.current.scrollTo({ top: this.state.scrollTo, left: 0 });
    }

    getPreviousValues = () => {
        const temp = getMaintainData(advanceSearchSub);
        this.setState({
            ...this.state,
            ...temp,
            loading: false,
        }, () => {
            this.scrollToPrevious();
        });
    }

    paramsDecrypt = () => {
        // const entries = atob(this.params.encryptData);
        const result = this.props.location.state.advancedSearchFilter;
        this.setState({
            pageLoading: true,
            searchData: result,
            clearAll: Object.keys(result.data).length === 0,
            noData: true
        }, () => {
            this.getItemsBasedOnSearch();
        });
    }

    getItemsBasedOnSearch = () => {
        const searchForm = Object.assign({}, this.searchForm);
        const searchData = this.state.searchData.data;
        Object.keys(searchData).forEach(key => {
            searchForm[key] = {
                value: searchData[key],
                name: searchForm[key].name,
                show: true
            }
        });
        this.setState({
            searchForm: searchForm,
            displayData: {
                ...this.state.displayData,
                patchData: { filter: this.state.searchData.filter.filter, page: { 'size': 48 }, sort: this.state.searchData.sort }
            },
            pageLoading: false
        })
    }

    getItemsList = (event) => {
        this.setState({
            noData: event.length === 0
        }, () => {
            this.headerStickyHandle();
            this.getRequiredData(event.scrollPage);
        });
        store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "ItemsForAdvanceSearch" } });
    }

    isCheckBox = (flag) => {
        const checkbox = ['auction', 'directBuy', 'onSite', 'completed', 'include', 'buynow', 'noreserve', 'pictureOnly', 'includeDescription', 'isshippable', 'pickuponly'];
        return checkbox.includes(flag)
    }

    removeKey = (flag) => {
        this.setState({
            searchForm: Object.assign({}, this.searchForm),
            pageLoading: true
        }, () => {
            const data = {};
            const filter = [];
            const sort = [{ "field": "title", "direction": "asc" }];
            const temp_data = this.state.searchData.data;
            const temp_filter = this.state.searchData.filter.filter;
            Object.keys(temp_data).forEach(key => {
                if (temp_data[key] && key !== flag) {
                    data[key] = temp_data[key];
                    switch (key) {
                        case "location":
                            const location = temp_filter.filter(x => x.field === "locationid");
                            if (location.length > 0) {
                                filter.push({ "field": "locationid", "value": location[0].value, "op": "=", "join": "AND" });
                            }
                            break;
                        case "category":
                            if (temp_data[key] !== "All Categories") {
                                const categoryGroupValue = temp_filter.filter(x => x.field === "categoryGroup");
                                const categoryValue = temp_filter.filter(x => x.field === "category");
                                if (categoryGroupValue.length > 0) {
                                    filter.push({ "field": "categoryGroup", "value": categoryGroupValue[0].value, "op": "=", "join": "AND" });
                                }
                                if (categoryValue.length > 0) {
                                    filter.push({ "field": "category", "value": categoryValue[0].value, "op": "=", "join": "AND" });
                                }
                            }
                            break;
                        case "keywords":
                            filter.push({ "field": "title", "value": `%${temp_data[key]}%`, "op": "LIKE", "join": "OR" });
                            filter.push({ "field": "tag", "value": `%${temp_data[key]}%`, "op": "LIKE", "join": "OR" });
                            filter.push({ "field": "description", "value": `%${temp_data[key]}%`, "op": "LIKE", "join": "AND" });
                            break;
                        case "zipcode":
                            filter.push({ "field": "zipcode", "value": temp_data[key], "op": "=", "join": "AND" });
                            break;
                        case "state":
                            filter.push({ "field": "state", "value": temp_data[key], "op": "=", "join": "AND" });
                            break;
                        case "country":
                            filter.push({ "field": "country", "value": temp_data[key], "op": "=", "join": "AND" });
                            break;
                        case "pricemin":
                            filter.push({ "field": "bidprice", "value": temp_data[key], "op": ">=", "join": "AND" });
                            break;
                        case "pricemax":
                            filter.push({ "field": "bidprice", "value": temp_data[key], "op": "<=", "join": "AND" });
                            break;
                        case "startDate":
                            filter.push({ "field": "starttime", "value": temp_data[key], "op": ">=", "join": "AND" });
                            break;
                        case "endDate":
                            filter.push({ "field": "endtime", "value": temp_data[key], "op": "<=", "join": "AND" });
                            break;
                        case "auction":
                            filter.push({ "field": "itemtypeid", "value": 2, "op": "=", "join": "AND" });
                            break;
                        case "directBuy":
                            filter.push({ "field": "itemtypeid", "value": 1, "op": "=", "join": "AND" });
                            break;
                        case "onSite":
                            filter.push({ "field": "itemtypeid", "value": 3, "op": "=", "join": "AND" });
                            break;
                        case "completed":
                            filter.push({
                                "field": "itemstatus",
                                "value": "Not Sold",
                                "op": "=",
                                "join": "OR"
                            });
                            filter.push({
                                "field": "itemstatus",
                                "value": "Sold",
                                "op": "=",
                                "join": "OR"
                            });
                            break;
                        case "include":
                            filter.push({ "field": "itemstatus", "value": "Sold", "op": "=", "join": "AND" });
                            break;
                        case "buynow":
                            filter.push({ "field": "buynowprice", "value": 0, "op": ">=", "join": "AND" });
                            break;
                        case "noreserve":
                            filter.push({ "field": "reserveprice", "value": 0, "op": "<=", "join": "AND" });
                            break;
                        case "sortBy":
                            const getList = temp_data[key].split('#*#');
                            // filter.push({ "field": "sortby", "value": getList[2], "op": "=", "join": "AND" });
                            sort[0] = { "field": getList[0], "direction": getList[1] };
                            break;
                        case "miles":
                            filter.push({ "field": "miles", "value": temp_data[key], "op": "=", "join": "AND" });
                            break;
                        case "isshippable":
                            filter.push({ "field": "isshippable", "value": 1, "op": "=", "join": "OR" });
                            break; 
                        case "pickuponly":
                            filter.push({ "field": "isshippable", "value": 0, "op": "=", "join": "AND" });
                            break;      
                        default:
                            console.error("Out of range");
                            break;
                    }
                }
            });
            if (!Object.keys(data).includes('completed')) {
                filter.push({ "field": "salestatus", "value": "Started", "op": "=", "join": "AND" });
                filter.push({ "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" })
            };
            if (Object.keys(data).length === 0) {
                this.setState({ clearAll: true }, () => {
                    this.navigate(data, filter, sort);
                });
            } else {
                this.navigate(data, filter, sort);
            }
        });
    }

    navigate = (data, filter, sort) => {
        const paramsData = { data, filter: { filter }, sort };
        const final = btoa(JSON.stringify(paramsData));
        this.props.history.push(`/advance-search/items/${final}`);
    }

    clearAll = () => {
        this.setState({
            searchForm: Object.assign({}, this.searchForm),
            pageLoading: true,
            clearAll: true
        }, () => {
            this.navigate({}, [{ "field": "salestatus", "value": "Started", "op": "=", "join": "AND" }, { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" }]);
        });
    }

    back = () => {
        enablePreviousState();
        if(this.props.history.location.state.fromScreen == "home") {
            this.props.history.push(`/`);
        } else {
            this.props.history.push(`/advance-search`);
        }
    }

    scrollToTop = () => {
        this.scrollRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    headerStickyHandle = () => {
        const header = document.getElementsByClassName('header')[0].getBoundingClientRect();
        this.setState({
            scrollHeight: header.bottom,
            pageClientWidth: this.scrollRef?.current?.clientWidth
        })
    }

    /* Called when scroll content */
    handleScroll = (event) => {
        try {
            this.setState({
                isVisible: (event.target.scrollHeight / 4) < event.target.scrollTop,
                scrollTo: event.target.scrollTop,
                pageClientWidth: this.scrollRef.current.clientWidth
            });
        } catch (e) {
            this.setState({
                isVisible: false
            });
        }
    };


    componentWillUnmount() {
        const data = {
            scrollTo: this.state.scrollTo
        };
        convertToMaintainData(advanceSearchSub, data);
        window.removeEventListener('resize', this.headerStickyHandle);
    }

    render() {

        <div className={`${this.state.clearAll ? 'pt-10' : ''}`}>
            <div className="d-md-flex align-items-center justify-content-between filter-conatainer">
                <div className="d-flex align-items-center flex-wrap form-control-conatainer">
                    {
                        React.Children.toArray(Object.keys(this.state.searchForm).map((key, index) =>
                            <>
                                {
                                    !this.isCheckBox(key) && this.state.searchForm[key].show ?
                                        <Form.Group controlId="searchon" className="form-control-main">
                                            <div className="close-icon clickable" onClick={() => this.removeKey(key)}>&#x2715;</div>
                                            <Form.Label>{this.state.searchForm[key].name}</Form.Label>
                                            <div className="form-control">
                                                {this.state.searchForm[key].value.indexOf('#*#') > -1 ? this.state.searchForm[key].value.split('#*#')[2] : this.state.searchForm[key].value}
                                            </div>
                                        </Form.Group> : null
                                }
                                {
                                    this.isCheckBox(key) && this.state.searchForm[key].show ?
                                        <div className="checkbox-remove">
                                            <div className="close-icon clickable" onClick={() => this.removeKey(key)}>&#x2715;</div>
                                            {this.state.searchForm[key].name}
                                        </div> : null
                                }
                            </>
                        ))
                    }
                    {
                        this.state.clearAll ? <div className="h5 fw-700">Items</div> : null
                    }
                </div>
                <div className="d-md-block d-lg-none divider"></div>
                <div className={`clickable clear-all ${this.state.clearAll ? 'custom-disable' : ''}`} onClick={this.clearAll}>Clear All</div>
            </div>
        </div>


        return (
            <div className="items-for-advance-search">
                {
                    this.state.pageLoading ? <div className="loader d-flex align-items-center justify-content-center">
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                    </div> : <div className="main-container">
                        <div className="header">
                            {/* <div className="header d-md-flex align-items-center"> */}
                            {/* <div className="d-flex align-items-center justify-content-between header-action-container">
                                <div className="back-icon">
                                    <div className="d-flex align-items-center clickable" onClick={this.back}>
                                        <div className="icon">
                                            <i className="fas fa-angle-left"></i>
                                        </div>
                                        <div className="text">Back</div>
                                    </div>
                                </div>

                                <div className="d-md-block d-lg-none">
                                    <Dropdown className="advance-search-filter-dropdown" >
                                        <Dropdown.Toggle id="filterItems" className="bg-transparent border-0">
                                            <div className="icon">
                                                <i className="fas fa-filter filter-icon"></i>
                                            </div>                                            </Dropdown.Toggle>
                                        <Dropdown.Menu className="shadow dropdown-menu-full md-screen">
                                            <div className="filter-section md-filter-section">
                                                {filters}
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                            <div className="filter-section d-none d-lg-block">
                                {filters}
                            </div> */}
                            <div className="breadcrumb-section">
                                <div className="back-button-title d-flex align-items-center">
                                    <div className="d-flex align-items-center clickable" onClick={this.back} >
                                        <div className="icon"style={{ backgroundColor:'#A50050' }}>
                                            <i className="fas fa-angle-left"></i>
                                        </div>
                                        <div className="text">Back</div>
                                        {
                                            this.props.history?.location?.state?.fromScreen === "home"  ? <div style={{color: 'black', marginLeft: '10px'}} >Showing results for : <span className="search-nlp">{this.props.location?.state?.advancedSearchFilter?.data?.zipcode ? this.props.location.state.advancedSearchFilter.data.zipcode : ''}</span></div> : ''
                                        }
                                    </div>
                                    {this.props.history?.location?.state?.fromScreen === "home" ? '' : <div className={`title w-100 ${this.state.NLP ? 'nlp-container' : 'text-center'} h5`}>
                                        Advanced Search
                                    </div> }
                                </div>
                            </div>
                        </div>

                        <div className="scroll-content" style={{ height: `calc(100% - ${this.state.scrollHeight}px)` }} ref={this.scrollRef} onScroll={this.handleScroll}>
                            {
                                this.state.isVisible ?
                                    <div className="scroll-top d-flex align-items-center justify-content-center clickable" style={{ right: `${window.innerWidth - this.state.pageClientWidth}px` }} onClick={this.scrollToTop}>
                                        <i className="fas fa-arrow-up"></i>
                                    </div> : null
                            }
                            <div className={`d-flex align-items-center justify-content-center ${this.state.noData ? 'h-75' : ''}`}>
                                <div className="large-screen-width">
                                    <SaleCardViewDataTable config={{ postData: this.state.displayData.patchData }}{...this.props} getItemsList={this.getItemsList} showMoreButton 
                                    addItemlistingtime addBidPrice showAd></SaleCardViewDataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default connect(state => state)(ItemsForAdvanceSearch);